import { useCallback, useEffect, useState } from "react"

const STORAGE_KEY = "migration_token"

function useMigration() {
  const [token, setToken] = useState<string | null>(null)
  const [isLoading, setIsLoading] = useState(false)

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search)
    const urlToken = urlParams.get("token")

    if (urlToken) {
      sessionStorage.setItem(STORAGE_KEY, urlToken)

      urlParams.delete("token")
      const newSearch = urlParams.toString()
      history.replaceState(null, "", newSearch ? `?${newSearch}` : window.location.pathname)

      setToken(urlToken)
    } else {
      const stored = sessionStorage.getItem(STORAGE_KEY)
      if (stored) setToken(stored)
    }
  }, [])

  const triggerMigration = useCallback(
    async (apiEndpoint: string): Promise<Response | null> => {
      if (!token) return null

      setIsLoading(true)
      try {
        const res = await fetch(apiEndpoint, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${token}`,
          },
          body: JSON.stringify({
            analytics: window.location.href,
          }),
        })

        if (res.ok) {
          sessionStorage.removeItem(STORAGE_KEY)
          return res
        }

        if (res.status === 401 || res.status === 403) {
          sessionStorage.removeItem(STORAGE_KEY)
          setToken(null)
        }
        return res
      } catch {
        return null
      } finally {
        setIsLoading(false)
      }
    },
    [token]
  )

  return { triggerMigration, hasMigrationToken: !!token, isLoading }
}

export default useMigration
